export const API_ENDPOINTS = {
    GET_ALL_PLANS : "/tremblant/get-all-plans",
    ACTIVATE_WATCH : "/ws/tremblant-provision",

    SUBMIT_NICK_NAME:"/entitlementmgt/ws/submit-nick-name",
    SUBMIT_CREDENTIALS:"/entitlementmgt/ws/submit-credentials",

    SUBMIT_QUERY_MULTI_SIM:"/entitlementmgt/ws/querymultisim",
    SUBMIT_RESUME_DELETE_SUSPEND:"/entitlementmgt/ws/submitresumesuspenddelete",

    ACCEPT_TNC: '/ws/consent-tc',
}